import { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ShellHeaderFallback from '@/components/app-shell/ShellHeaderFallback';
import { PageHeader } from '@/components/shared/PageHeader';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useShellBreadcrumbs from '@/data/hook/app-shell/useShellBreadcrumbs';
import useCourseLessonsBreadcrumbs from '@/data/hook/course-progress/useCourseLessonsBreadcrumbs';

type CourseLessonsHeaderProps = {
  backHref?: string;
  actions?: ReactNode;
};

export default function CourseLessonsHeader({
  backHref,
  actions,
}: CourseLessonsHeaderProps) {
  const navigate = useNavigate();
  const breadcrumbs = useCourseLessonsBreadcrumbs();
  useShellBreadcrumbs(breadcrumbs);

  const goBack = () => {
    if (backHref) return navigate(backHref);
    navigate(-1);
  };

  return (
    <ShellHeaderFallback>
      <PageHeader className="py-4 md:py-2 lg:p-4">
        <PageHeader.Row>
          <ShellHeaderFallback.Back onClick={goBack} />
          <PageHeader.Title className="hidden md:block">
            <Trans
              i18nKey="courseLessons.header.title"
              components={{ highlight: <span className="text-primary" /> }}
            />
          </PageHeader.Title>
          <ConditionalRenderer condition={!!actions}>
            <PageHeader.Actions className="md:mr-10 lg:mr-0">
              {actions}
            </PageHeader.Actions>
          </ConditionalRenderer>
        </PageHeader.Row>
        <PageHeader.Row className="hidden md:flex">
          <PageHeader.Breadcrumbs items={breadcrumbs} />
        </PageHeader.Row>
      </PageHeader>
    </ShellHeaderFallback>
  );
}
